import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { store } from 'redux-rest-reducer';
import { Separator, Text, Row, Button } from '@cuemath/comps';

import { closeModal } from 'actions/modal';
import { Form, Header, Checkbox, Card } from 'semantic-ui-react';
import COLORS from 'constants/colors';
import { Close } from 'styled-icons/material/Close';
import { Warning } from 'styled-icons/material/Warning';

import {
  post as postSubmitData,
  patch as patchEditData,
  get as getEditSheet,
} from 'actions/curriculum-add-sheet';

import { HeaderHead, Message, renderFormField } from 'modules/form';

import {
  FIELD_TYPES,
  addSheetFields,
  getInputChangeMethod,
  getOnChangeMethod,
} from 'constants/form';

const ButtonWrapper = styled.div`
  opacity: ${({ close }) => (close ? `0.1` : `1`)};
  pointer-events: ${({ close }) => (close ? `none` : `all`)};
`;

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${({ close }) => (close ? `0.1` : `1`)};
  pointer-events: ${({ close }) => (close ? `none` : `all`)};
`;

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 0px 10px 10px 10px;
  margin-top: 10px;
  bottom: 7px;
  position: relative;
`;

const FieldWrapper = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  opacity: ${({ close }) => (close ? `0.1` : `1`)};
  pointer-events: ${({ close }) => (close ? `none` : `all`)};
`;

const LOCATION = ['CW', 'HW', 'ANY'];

const RadioInput = styled(Text)`
  padding-right: 5px;
  bottom: 3px;
  position: relative;
  padding-left: 14px;
`;

const GridItems = styled(Row)`
  font-size: 14px;
  margin-bottom: 10px;
  padding: 0px 5px;
  display: flex;
`;

const InputStyled = styled(Form.Input)`
  position: relative;
  top: 20px;
  right: 85px;
  width: 90px;
`;

const FormInput = styled(Form.Input)`
  padding-left: 14px;
`;

const FormSelect = styled(Form.Select)`
  padding-left: 14px;
  .ui.dropdown {
    min-width: 25% !important;
    max-width: 40%;
  }
`;

const FormField = styled(Form.Field)`
  padding-left: 14px;
`;

const Input = styled.input`
  height: 16px;
  width: 16px;
`;

const RadioText = styled(Text)`
  margin-left: 5px;
  bottom: 4px;
  position: relative;
`;

const ButtonStyle = styled.span`
  margin-left: 20px;
`;

const CloseIcon = styled(Close)`
  position: absolute;
  top: 10px;
  z-index: 2;
  right: 15px;
  width: 20px;
  height: 20px;
  float: right;
  cursor: pointer;
`;

const WarningIcon = styled(Warning)`
  position: absolute;
  top: 40px;
  width: 40px;
  height: 40px;
  transform: translateY(-50%);
  margin: 0 auto;
  color: ${COLORS.COLA};
`;

const AlertCard = styled(Card)`
  position: absolute;
  height: 230px;
  min-width: 400px;
  margin: 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 16px;
  z-index: 9999;
  opacity: 1;
  margin-bottom: 20px;
  pointer-events: all;
`;

const AlertModalRow = styled(Row)`
  padding: 20px;
  width: 400px;
`;

const AssignStyle = styled(Text)`
  width: 400px;
`;

const ButtonNo = styled.div`
  position: relative;
  background: #ffffff;
  border: 1.76087px solid #e2e4eb;
  box-sizing: border-box;
  border-radius: 24.6522px;
  width: 135px;
  height: 32px;
  cursor: pointer;
  margin-left: 10px;
`;

const ButtonYes = styled.div`
  position: relative;
  background: ${COLORS.CERULEAN};
  border-radius: 28px;
  width: 135px;
  height: 32px;
  cursor: pointer;
`;

const AlertStyle = styled(Row)`
  width: 240px;
  margin: 0 auto;
`;

const ExitText = styled(Text)`
  padding: 10px;
  margin-top: 60px;
`;

const NoText = styled.div`
  position: relative;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  top: 5px;
`;

const LOCATION_FILTER = {
  CW: 'INCLASS',
  HW: 'ATHOME',
  ANY: 'ANY',
};
const SELECTED_LOCATION = {
  INCLASS: 'CW',
  ATHOME: 'HW',
  ANY: 'ANY',
};

const FILTER = {
  BOARDS: 'boards',
  TOPICS: 'topics',
  TYPES: 'node_types',
  GRADES: 'grades',
};

const COMPLETED_IN = ['=', '<', '>', '<=', '>='];
const REATTEMPT_CRITERIA = ['=', '<', '>', '<=', '>='];

const getFormDefaults = editSheetData => {
  const formDefaults = {};

  addSheetFields.forEach(field => {
    if (
      !!editSheetData &&
      (editSheetData[field.param] || editSheetData.worksheet[field.param])
    ) {
      if (field.name === FILTER.GRADES) {
        let gradeArr = [];
        editSheetData[field.param].forEach(rec => gradeArr.push(rec.id));
        formDefaults[field.name] = gradeArr;
      }

      if (field.name === FILTER.BOARDS) {
        let boardsArr = [];
        editSheetData[field.param].forEach(rec => boardsArr.push(rec.id));
        formDefaults[field.name] = boardsArr;
      }

      if (field.name === FILTER.TOPICS) {
        let topicsArr = [];
        editSheetData[field.param].forEach(rec => topicsArr.push(rec.id));
        formDefaults[field.name] = topicsArr;
      }

      if (field.name === FILTER.TYPES) {
        formDefaults[field.name] =
          !!editSheetData && editSheetData[field.param]
            ? editSheetData[field.param]
            : field.default;
      }

      if (
        field.name !== FILTER.GRADES &&
        field.name !== FILTER.BOARDS &&
        field.name !== FILTER.TOPICS &&
        field.name !== FILTER.TYPES
      ) {
        formDefaults[field.name] =
          !!editSheetData && editSheetData.worksheet[field.param]
            ? editSheetData.worksheet[field.param]
            : field.default;
      }
    } else {
      formDefaults[field.name] = field.default;
    }
  });

  return formDefaults;
};
class AddSheet extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
      errorText: null,
      message: null,
      editSheetPatch: store.patch(),
      form: getFormDefaults(),
      formFields: this.getFormFields(),
      addData: null,
      dropdownData: {},
      toggleData: {},
      addSheetPost: store.post(),
      location: null,
      showConfirmation: false,
      submitDone: false,
      closeModal: false,
    };

    addSheetFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  static propTypes = {
    actions: PropTypes.shape({
      postSubmitData: PropTypes.func.isRequired,
      closeModal: PropTypes.func.isRequired,
    }).isRequired,
    programs: PropTypes.array.isRequired,
    isEditSheet: PropTypes.shape({}).isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    const { curriculumAddSheet, nodeId, isEditSheet, getFilteredPrograms } = props;
    const { addSheetPost, editSheetPatch, editSheetData, message } = state;
    const { is_available: isAvailable } = isEditSheet || {};

    const postAddSheet = store.post(curriculumAddSheet, addSheetPost.id);
    const patchEditSheet = store.patch(curriculumAddSheet, editSheetPatch.id);
    const getEditSheet = store.get(curriculumAddSheet, nodeId);

    const newState = {};

    if (getEditSheet && getEditSheet.isLoaded && !editSheetData) {
      newState.editSheetData = getEditSheet.data;
      const {
        attempt_location: attemptLocation,
        is_timed: isTimed,
        sheet_time: sheetTime,
        complete_criteria: completionCriteria,
        reattempt_criteria: reattemptCriteria,
        complete_in: completeIn,
        reattempt_in: reattemptIn,
        worksheet,
      } = getEditSheet.data || {};
      const {
        is_lesson_v3_enabled: isLessonV3Enabled,
        desmos_calculator_enabled: isDesmosCalcEnabled,
      } = worksheet || {};
      const { operator, right } = completionCriteria || {};
      const { operator: reattemptOperator, right: reattemptRight } =
        reattemptCriteria || {};
      newState.location = SELECTED_LOCATION[attemptLocation];
      newState.toggleData = {
        timed: isTimed,
        is_available: isAvailable,
        is_lesson_v3_enabled: isLessonV3Enabled,
        desmos_calculator_enabled: isDesmosCalcEnabled,
      };

      newState.dropdownData = {
        reattempt_criteria: reattemptOperator,
        completion_criteria: operator,
      };
      newState.addData = {
        time: !isTimed ? '' : sheetTime && sheetTime / 60,
        complete_in: completeIn,
        completion_criteria_text: right && right.value,
        reattempt_criteria_text: reattemptRight && reattemptRight.value,
        reattempt_in: reattemptIn,
      };
      newState.form = getFormDefaults(getEditSheet.data);
    }

    if (postAddSheet.resolved) {
      if (postAddSheet.resolved.isCreated && !message) {
        newState.submitDone = true;
        newState.errorText = '';
        newState.message = 'Worksheet added.';
        getFilteredPrograms();
      } else if (postAddSheet.resolved.isCreatingFailed) {
        newState.submitDone = false;
        newState.message = '';
        newState.errorText = 'Error encountered! Please verify the inputs provided.';
      }
    }

    if (patchEditSheet.resolved) {
      if (patchEditSheet.resolved.isPatched && !message) {
        newState.submitDone = true;
        newState.errorText = '';
        newState.message = 'Worksheet updated.';
        getFilteredPrograms();
      } else if (patchEditSheet.resolved.isPatchingFailed) {
        newState.submitDone = false;
        newState.message = '';
        newState.errorText = 'Error encountered! Please verify the inputs provided.';
      }
    }

    return newState;
  }

  componentDidMount() {
    const { actions, nodeId } = this.props;
    const { editSheetData } = this.state;

    if (nodeId) {
      actions.getEditSheet(nodeId);
    }

    if (editSheetData) {
      this.setState(() => ({
        form: getFormDefaults(editSheetData),
      }));
    }
  }

  componentDidUpdate() {
    const { submitDone } = this.state;

    if (submitDone) {
      this.timeout = setTimeout(() => {
        this.onCloseModal();
      }, 3000);
    }
  }

  disableAddSheet = () => {
    const { form, addData, location, toggleData } = this.state;

    const { boards, grades, name, reference, topics, node_types: nodeType } = form || {};
    const { timed } = toggleData || {};
    const {
      time,
      complete_in: completedIn,
      completion_criteria_text: completionText,
      reattempt_criteria_text: reattemptText,
      reattempt_in: reattemptIn,
    } = addData || {};

    const checkTime = timed ? timed && time : true;
    const isCompletedInAvailable = completedIn !== undefined && String(completedIn);
    const isReattemptInAvailable = reattemptIn !== undefined && String(reattemptIn);

    if (
      !(
        boards &&
        grades &&
        topics &&
        name &&
        reference &&
        nodeType &&
        checkTime &&
        isCompletedInAvailable &&
        completionText &&
        reattemptText &&
        isReattemptInAvailable &&
        location
      ) ||
      (boards && Array.isArray(boards) && !boards.length) ||
      (grades && Array.isArray(grades) && !grades.length) ||
      (topics && Array.isArray(topics) && !topics.length) ||
      !(
        name &&
        reference &&
        nodeType &&
        checkTime &&
        isCompletedInAvailable &&
        completionText &&
        reattemptText &&
        isReattemptInAvailable &&
        location
      )
    ) {
      return true;
    }

    return false;
  };

  onCloseModal = () => {
    const { actions } = this.props;

    this.setState({ editSheetData: null });

    actions.closeModal();
  };

  getCheckOptions = (options, isIdTrue) => {
    let arr = [];

    if (isIdTrue) {
      arr = options.map(opt => {
        return { label: opt.name, value: opt.id };
      });
    } else {
      arr = options.map(opt => {
        return { label: opt.name, value: opt.code };
      });
    }

    return arr;
  };

  getFormFields = () => {
    const { programs } = this.props;

    return addSheetFields.map(field => {
      if (programs[field.name]) {
        if (field.fieldType === FIELD_TYPES.SELECT) {
          if (field.name === FILTER.GRADES) {
            programs[field.name].sort((a, b) =>
              parseInt(a.name, 10) > parseInt(b.name, 10) ? 1 : -1,
            );
          }

          field.choices = this.getCheckOptions(
            programs[field.name],
            !!programs[field.name][0].id,
          );
        }
      }

      return field;
    });
  };

  onChange = (key, value) => {
    const { form } = this.state;
    const newForm = { ...form };
    newForm[key] = value;
    const stateChanges = { form: newForm };
    this.setState(() => ({ ...stateChanges }));
  };

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;

    const newForm = { ...form };

    newForm[key] = value;

    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onAddSheetClicked = () => {
    const { showConfirmation } = this.state;

    this.setState({ showConfirmation: !showConfirmation });
  };

  handleChange = e => {
    let tempActivityNodeData = Object.assign({}, this.state.addData);
    tempActivityNodeData[e.target.name] = e.target.value;

    this.setState({
      addData: tempActivityNodeData,
    });
  };

  handleChangeDropdown = (event, { name, key, value }) => {
    let tempData = Object.assign({}, this.state.dropdownData);
    tempData[name] = value;

    this.setState({
      dropdownData: tempData,
    });
  };

  handleChangeCheckbox = (e, { checked, name }) => {
    let tempData = Object.assign({}, this.state.toggleData);
    tempData[name] = checked;

    this.setState({
      toggleData: tempData,
    });
  };

  checkIfOptionsChanged = (oldOptions, newOptions) => {
    let isSame;

    if (oldOptions && newOptions) {
      isSame =
        oldOptions &&
        newOptions &&
        oldOptions.length === newOptions.length &&
        oldOptions.every((element, index) => {
          return element.id === newOptions[index];
        });
    } else if (!oldOptions && newOptions && newOptions.length) {
      isSame = false;
    }

    return isSame;
  };

  getUpdatedFields = () => {
    const { isEditSheet } = this.props;
    const {
      form,
      location,
      toggleData,
      dropdownData,
      addData,
      editSheetData,
    } = this.state;
    const { node_type: prevNodeType, is_available: prevLive } = isEditSheet || {};
    const {
      is_timed: prevIsTimed,
      attempt_location: prevAttemptLocation,
      complete_criteria: prevCompleteCriteria,
      reattempt_criteria: prevReattempt,
      boards: prevBoards,
      grades: prevGrades,
      topics: prevTopics,
      worksheet,
      complete_in: prevCompleteIn,
      reattempt_in: prevReattemptIn,
      sheet_time: prevSheetTime,
    } = editSheetData || {};
    const {
      name: prevName,
      learnosity_activity_ref: prevReference,
      is_lesson_v3_enabled: prevIsLessonV3Enabled,
      desmos_calculator_enabled: prevIsDesmosCalcEnabled,
    } = worksheet || {};

    const { node_types: nodeType, boards, grades, name, reference, topics } = form || {};

    const {
      timed,
      is_available: live,
      is_lesson_v3_enabled: isLessonV3Enabled,
      desmos_calculator_enabled: isDesmosCalcEnabled,
    } = toggleData || {};
    const {
      completion_criteria_text: completionText,
      reattempt_criteria_text: reattemptText,
      complete_in: completedIn,
      reattempt_in: reattemptIn,
      time,
    } = addData || {};
    const {
      reattempt_criteria: reattemptSign = '<',
      completion_criteria: completionSign = '>=',
    } = dropdownData || {};

    let patchObj = {};

    const isTopicSame = this.checkIfOptionsChanged(prevTopics, topics);
    const isGradeSame = this.checkIfOptionsChanged(prevGrades, grades);
    const isBoardSame = this.checkIfOptionsChanged(prevBoards, boards);

    if (
      (nodeType && !prevNodeType) ||
      (nodeType && prevNodeType && nodeType.toLowerCase() !== prevNodeType.toLowerCase())
    )
      patchObj.node_type = nodeType;
    if (location && location !== SELECTED_LOCATION[prevAttemptLocation])
      patchObj.attempt_location = LOCATION_FILTER[location];
    if (timed !== prevIsTimed) patchObj.is_timed = timed;
    if (
      (completionText && !prevCompleteCriteria) ||
      (completionText &&
        prevCompleteCriteria &&
        ((prevCompleteCriteria.right &&
          prevCompleteCriteria.right.value !== completionText) ||
          prevCompleteCriteria.operator !== completionSign))
    ) {
      if (patchObj.complete_criteria) {
        patchObj.complete_criteria.value = completionText;
        patchObj.complete_criteria.operator = completionSign;
      } else {
        patchObj.complete_criteria = {};
        patchObj.complete_criteria.value = completionText;
        patchObj.complete_criteria.operator = completionSign;
      }
    }

    if (
      (reattemptText && !prevReattempt) ||
      (reattemptText &&
        prevReattempt &&
        ((prevReattempt.right && prevReattempt.right.value !== reattemptText) ||
          prevReattempt.operator !== reattemptSign) &&
        reattemptSign)
    ) {
      if (patchObj.reattempt_criteria) {
        patchObj.reattempt_criteria.operator = reattemptSign;
        patchObj.reattempt_criteria.value = reattemptText;
      } else {
        patchObj.reattempt_criteria = {};
        patchObj.reattempt_criteria.operator = reattemptSign;
        patchObj.reattempt_criteria.value = reattemptText;
      }
    }
    if (name && name !== prevName) patchObj.name = name;

    if (reference && reference !== prevReference)
      patchObj.learnosity_activity_ref = reference;
    if (live !== prevLive) patchObj.is_available = live;
    if (isLessonV3Enabled !== prevIsLessonV3Enabled)
      patchObj.is_lesson_v3_enabled = isLessonV3Enabled;
    if (isDesmosCalcEnabled !== prevIsDesmosCalcEnabled)
      patchObj.desmos_calculator_enabled = isDesmosCalcEnabled;
    if (completedIn && completedIn !== prevCompleteIn) patchObj.complete_in = completedIn;
    if (reattemptIn && reattemptIn !== prevReattemptIn)
      patchObj.reattempt_in = reattemptIn;
    if (time !== prevSheetTime) {
      patchObj.sheet_time = time * 60;
    }
    if (!isTopicSame && typeof isTopicSame !== 'undefined') patchObj.topic_ids = topics;
    if (!isGradeSame && typeof isGradeSame !== 'undefined') patchObj.grade_ids = grades;
    if (!isBoardSame && typeof isBoardSame !== 'undefined') patchObj.board_ids = boards;

    return patchObj;
  };

  shouldCreateNewSheet = () => {
    const {
      form,
      location,
      toggleData,
      dropdownData,
      addData,
      editSheetData,
    } = this.state;

    const {
      is_timed: prevIsTimed,
      attempt_location: prevAttemptLocation,
      complete_criteria: prevCompleteCriteria,
      reattempt_criteria: prevReattempt,
      node_type: prevNodeType,
    } = editSheetData || {};

    const { node_types: nodeType } = form || {};
    const { timed } = toggleData || {};
    const {
      completion_criteria_text: completionText,
      reattempt_criteria_text: reattemptText,
    } = addData || {};
    const {
      reattempt_criteria: reattemptSign = '<',
      completion_criteria: completionSign = '>=',
    } = dropdownData || {};

    let isNewSheet = false;

    if (
      (nodeType &&
        prevNodeType &&
        nodeType.toLowerCase() !== prevNodeType.toLowerCase()) ||
      (location && location !== SELECTED_LOCATION[prevAttemptLocation]) ||
      timed !== prevIsTimed ||
      (completionText && !prevCompleteCriteria) ||
      (completionText &&
        prevCompleteCriteria &&
        prevCompleteCriteria.right &&
        prevCompleteCriteria.right.value !== completionText) ||
      (completionSign &&
        prevCompleteCriteria &&
        prevCompleteCriteria.operator !== completionSign) ||
      (reattemptText && !prevReattempt) ||
      (reattemptText &&
        prevReattempt &&
        prevReattempt.right &&
        prevReattempt.right.value !== reattemptText) ||
      (reattemptSign && prevReattempt && prevReattempt.operator !== reattemptSign)
    ) {
      isNewSheet = true;
    }

    return isNewSheet;
  };

  onConfirm = () => {
    const { actions, nodeId } = this.props;
    const {
      form,
      addData,
      dropdownData,
      location,
      toggleData,
      editSheetPatch: { id: patchId },
      addSheetPost: { id },
      editSheetData,
    } = this.state;

    const { boards, grades, name, reference, topics, node_types: nodeType } = form || {};
    const {
      time,
      complete_in: completedIn,
      completion_criteria_text: completionText,
      reattempt_criteria_text: reattemptText,
      reattempt_in: reattemptIn,
    } = addData || {};
    const {
      reattempt_criteria: reattemptSign = '<',
      completion_criteria: completionSign = '>=',
    } = dropdownData || {};
    const { is_available: live, timed, is_lesson_v3_enabled: isLessonV3Enabled } =
      toggleData || {};

    const postObj = {
      node_type: nodeType,
      is_timed: !timed ? false : timed,
      complete_criteria: {
        operator: completionSign,
        value:
          !completionText &&
          editSheetData &&
          editSheetData.complete_criteria &&
          editSheetData.complete_criteria.right &&
          editSheetData.complete_criteria.right.value
            ? editSheetData.complete_criteria.right.value
            : completionText,
      },
      reattempt_criteria: {
        operator: reattemptSign,
        value:
          !reattemptText &&
          editSheetData &&
          editSheetData.reattempt_criteria &&
          editSheetData.reattempt_criteria.right &&
          editSheetData.reattempt_criteria.right.value
            ? editSheetData.reattempt_criteria.right.value
            : reattemptText,
      },
      attempt_location: LOCATION_FILTER[location],
      name: name,
      learnosity_activity_ref: reference,
      sheet_time: !timed ? 40 * 60 : time * 60,
      complete_in: completedIn,
      reattempt_in: reattemptIn,
      is_available: !live ? false : true,
      topic_ids: topics,
      grade_ids: grades,
      board_ids: boards,
      is_lesson_v3_enabled: isLessonV3Enabled || false,
    };

    if (nodeId) {
      const patchData = this.getUpdatedFields();
      const patchObj = {
        action: 'UPDATE',
        action_data: patchData,
      };

      actions.patchEditData(patchId, nodeId, patchObj);
    } else {
      actions.postSubmitData(id, postObj);
    }
  };

  handleRadioButtonChange = e => {
    this.setState({ location: e });
  };

  renderFormFields = () => {
    const { formFields, form, submitDone, closeModal } = this.state;
    return (
      <FieldWrapper close={closeModal}>
        {formFields &&
          formFields.length &&
          formFields.map((field, index) => {
            field.profileView = true;
            const disabled = submitDone ? submitDone : field.disabled;
            const required = field.required;
            const placeholder = disabled ? '' : field.label;

            return (
              <div key={`${field.name}-${index}`}>
                {renderFormField({
                  ...field,
                  profileForm: true,
                  value: form[field.name],
                  onChange: this[getInputChangeMethod(field)],
                  required,
                  disabled,
                  placeholder,
                  maxlength: field.maxlength,
                })}
              </div>
            );
          })}
      </FieldWrapper>
    );
  };

  renderFormHeader = () => {
    const { editSheetData, closeModal } = this.state;

    return (
      <HeaderHeadWrapper close={closeModal}>
        <Header as="h3" floated="left">
          <CloseIcon onClick={this.onCloseClicked} />
          <Separator height={10} transparent />
          {!editSheetData && (
            <Text weight="bold" color="rgba(0,0,0,.87)">
              Add New Sheet
            </Text>
          )}
          {!!editSheetData && (
            <Text weight="bold" color="rgba(0,0,0,.87)">
              Edit Sheet
            </Text>
          )}
        </Header>
      </HeaderHeadWrapper>
    );
  };

  onCloseClicked = () => {
    const { closeModal } = this.state;
    const { actions } = this.props;

    const changedObj = this.getUpdatedFields();

    const containsDefault =
      changedObj &&
      Object.values(changedObj).length > 0 &&
      Object.values(changedObj).includes('');

    const changesDone =
      changedObj && Object.keys(changedObj).length > 0 && !containsDefault;

    if (changesDone) {
      this.setState({ closeModal: !closeModal });
    } else {
      actions.closeModal();
    }
  };

  onModalClose = () => {
    return (
      <AlertModalRow>
        <AlertCard>
          <AlertStyle justifyContent="center">
            <WarningIcon />
            <Separator height={15} transparent />
            <ExitText align="center">All unsaved changes will be lost.</ExitText>
            <Text align="center">Are you sure you want to close this window?</Text>
          </AlertStyle>
          <Separator height={15} transparent />
          <Row justifyContent="center">
            <ButtonYes onClick={() => this.onCloseModal()}>
              <NoText color={COLORS.WHITE}>Close</NoText>{' '}
            </ButtonYes>
            <ButtonNo onClick={() => this.onCloseClicked()}>
              <NoText color="#01A5F2">Cancel</NoText>
            </ButtonNo>
          </Row>
          <Separator height={20} transparent />
        </AlertCard>
        <Separator height={20} transparent />
      </AlertModalRow>
    );
  };

  renderFormFooter = () => {
    const {
      submitDone,
      dropdownData,
      location,
      addData,
      toggleData,
      closeModal,
    } = this.state;
    const {
      is_available: live,
      timed,
      is_lesson_v3_enabled: isLessonV3Enabled,
      desmos_calculator_enabled: isDesmosCalcEnabled,
    } = toggleData || {};

    const {
      time,
      complete_in: completedIn,
      completion_criteria_text: completionText,
      reattempt_criteria_text: reattemptText,
      reattempt_in: reattemptIn,
    } = addData || {};
    const {
      reattempt_criteria: reattemptOp = '<',
      completion_criteria: completionOp = '>=',
    } = dropdownData || {};
    const completionSign =
      dropdownData && !dropdownData.completion_criteria
        ? '>='
        : dropdownData.completion_criteria;
    const reattemptSign =
      dropdownData && !dropdownData.reattempt_criteria
        ? '<'
        : dropdownData.reattempt_criteria;

    const disableTime = !timed || submitDone;

    return (
      <FieldWrapper key="sheets" close={closeModal}>
        <Form onChange={this.handleChange}>
          <Row>
            <FormField label="Timed" control="checkbox">
              <Checkbox
                name="timed"
                toggle
                label=""
                checked={timed}
                onChange={this.handleChangeCheckbox}
                disabled={submitDone}
              />
            </FormField>
            <Form.Input
              name="time"
              label={'Time'}
              value={time}
              width={4}
              placeholder={disableTime ? '' : 'min'}
              disabled={disableTime}
              type="number"
            />
          </Row>
          <Separator height={20} transparent />
          <Row>
            <Separator height={10} transparent />
            <RadioInput>Location:</RadioInput>
            <Separator height={10} transparent />
            {LOCATION &&
              LOCATION.map(ltn => {
                return (
                  <GridItems>
                    <label key={`radio_type_${ltn}`}>
                      <Row>
                        <Input
                          type="radio"
                          disabled={submitDone}
                          name="radio_type"
                          onChange={() => this.handleRadioButtonChange(ltn)}
                          checked={location === ltn}
                        />
                        <RadioText>{ltn}</RadioText>
                      </Row>
                    </label>
                  </GridItems>
                );
              })}
          </Row>
          <Separator height={20} transparent />
          <Row>
            <FormSelect
              name={'completion_criteria'}
              label={'Completion Percent'}
              options={COMPLETED_IN.map(op => ({ key: op, text: op, value: op }))}
              disabled={submitDone}
              onChange={this.handleChangeDropdown}
              value={!completionSign ? completionOp : completionSign}
              width={5}
            />

            <InputStyled
              name="completion_criteria_text"
              label={''}
              placeholder={'criteria'}
              disabled={submitDone}
              value={completionText}
              type="number"
            />
          </Row>
          <Separator height={20} transparent />
          <Row>
            <FormSelect
              name={'reattempt_criteria'}
              label={'Reattempt Percent'}
              options={REATTEMPT_CRITERIA.map(op => ({ key: op, text: op, value: op }))}
              onChange={this.handleChangeDropdown}
              disabled={submitDone}
              value={!reattemptSign ? reattemptOp : reattemptSign}
              width={5}
            />
            <InputStyled
              name="reattempt_criteria_text"
              label={''}
              placeholder={'criteria'}
              disabled={submitDone}
              value={reattemptText}
              type="number"
            />
          </Row>
          <Separator height={20} transparent />
          <Row justifyContent="space-between">
            <FormInput
              name="complete_in"
              label={'Complete in'}
              width={4}
              placeholder={'days'}
              disabled={submitDone}
              value={completedIn}
              type="number"
            />

            <Separator height={10} transparent />
            <Form.Input
              name="reattempt_in"
              label={'Reattempt in'}
              width={4}
              placeholder={'hours'}
              disabled={submitDone}
              value={reattemptIn}
              type="number"
            />
          </Row>
          <Separator height={20} transparent />
          <Row justifyContent="space-between">
            <FormField label="Live" control="checkbox">
              <Checkbox
                name="is_available"
                toggle
                label=""
                onChange={this.handleChangeCheckbox}
                disabled={submitDone}
                value={reattemptSign}
                checked={live}
              />
            </FormField>
            <Form.Field label={'Is Lesson V3 enabled?'} control="checkbox">
              <Checkbox
                name={'is_lesson_v3_enabled'}
                toggle
                label="Yes"
                checked={isLessonV3Enabled}
                disabled={submitDone}
                onChange={this.handleChangeCheckbox}
              />
            </Form.Field>
            <Form.Field label={'Is Desmos Calculator enabled?'} control="checkbox">
              <Checkbox
                name={'desmos_calculator_enabled'}
                toggle
                label="Yes"
                checked={isDesmosCalcEnabled}
                disabled={submitDone}
                onChange={this.handleChangeCheckbox}
              />
            </Form.Field>
          </Row>
          <Separator height={40} transparent />
        </Form>
      </FieldWrapper>
    );
  };

  render() {
    const {
      errorText,
      message,
      showConfirmation,
      editSheetData,
      closeModal,
    } = this.state;

    const isButtonDisabled = this.disableAddSheet();

    const showNewSheetConfirmation = this.shouldCreateNewSheet();

    return (
      <FormWrapper>
        {this.renderFormHeader()}
        {closeModal && this.onModalClose()}
        <Separator transparent height="25" />
        {this.renderFormFields()}
        <Separator transparent height="25" />
        {this.renderFormFooter()}
        {errorText && <Message error={true}>{errorText}</Message>}
        {message && <Message>{message}</Message>}
        {!showConfirmation && (
          <ButtonWrapper close={closeModal}>
            {!editSheetData && (
              <div>
                <Separator height="20" transparent />
                <Button
                  label="Add Sheet"
                  disabled={isButtonDisabled || message}
                  onClick={this.onAddSheetClicked}
                />
              </div>
            )}
            {!!editSheetData && (
              <div>
                <Separator height="20" transparent />
                <Row>
                  <Button
                    label="Save Changes"
                    disabled={isButtonDisabled || message}
                    onClick={this.onAddSheetClicked}
                  />
                  <ButtonStyle>
                    <Button
                      label="Cancel"
                      disabled={message}
                      onClick={this.onCloseModal}
                    />
                  </ButtonStyle>
                </Row>
              </div>
            )}
          </ButtonWrapper>
        )}

        {showConfirmation && (
          <ButtonWrapper close={closeModal}>
            {!editSheetData && !message && !errorText && (
              <Text>Do you want to add this sheet?</Text>
            )}
            {!!editSheetData && !message && !errorText && !showNewSheetConfirmation && (
              <Text>Do you want to make these changes?</Text>
            )}
            {showNewSheetConfirmation && !!editSheetData && !message && !errorText && (
              <AssignStyle align="center">
                This will create a new version of this sheet. Already assigned sheets
                won't be affected. Do you want to proceed?
              </AssignStyle>
            )}
            <Separator height="20" transparent />
            <Row justifyContent="center">
              <Button
                label="Confirm"
                disabled={isButtonDisabled || message}
                onClick={this.onConfirm}
              />
              <ButtonStyle>
                <Button
                  label="Cancel"
                  disabled={message}
                  onClick={this.onAddSheetClicked}
                />
              </ButtonStyle>
            </Row>
          </ButtonWrapper>
        )}
        <Separator height={40} transparent />
      </FormWrapper>
    );
  }
}

export default connect(
  ({ curriculumAddSheet, nodeId }) => ({
    curriculumAddSheet,
    editSheet: store.get(curriculumAddSheet, nodeId),
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        closeModal,
        postSubmitData,
        patchEditData,
        getEditSheet,
      },
      dispatch,
    ),
  }),
)(AddSheet);
